import React from "react";
import { UserCircle2, Disc3, Hash, Wallet } from "lucide-react";

const steps = [
  {
    icon: UserCircle2,
    title: "اختر نوع الحساب",
    desc: "حدد ما إذا كان حسابك خليجي، أفريقي، متوسط، أو عالمي.",
  },
  {
    icon: Disc3,
    title: "اختر نوع العجلة",
    desc: "حدد العجلة المتاحة في اللعبة التي تريد إكمالها.",
  },
  {
    icon: Hash,
    title: "عدد السحبات المنفذة",
    desc: "أدخل عدد السحبات التي قمت بها فعلياً من هذه العجلة.",
  },
  {
    icon: Wallet,
    title: "رصيدك من CP",
    desc: "أدخل رصيد CP الحالي في حسابك، وسنحسب لك الفرق تلقائياً.",
  },
];

const HowToUse = () => {
  return (
    <section id="how" className="max-w-6xl mx-auto px-4 sm:px-6 py-16">
      <div className="text-center mb-10">
        <h2 className="text-2xl sm:text-4xl font-bold text-white">
          كيف تستخدم الحاسبة؟
        </h2>
        <p className="text-white/60 mt-3">أربع خطوات بسيطة للحصول على نتيجة دقيقة</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {steps.map((s, i) => (
          <div
            key={i}
            className="relative rounded-2xl bg-white/[0.03] border border-white/10 p-5 hover:border-yellow-500/40 transition-colors"
          >
            <div className="absolute -top-3 -start-3 w-8 h-8 rounded-lg bg-yellow-500 text-[#0A1128] font-black flex items-center justify-center text-sm shadow-lg">
              {i + 1}
            </div>
            <div className="w-12 h-12 rounded-xl bg-blue-600/20 border border-blue-500/30 flex items-center justify-center mb-4">
              <s.icon className="w-6 h-6 text-blue-300" />
            </div>
            <div className="text-white font-bold text-lg">{s.title}</div>
            <div className="text-white/60 text-sm mt-2 leading-relaxed">{s.desc}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HowToUse;
